<template>
  <Head title="Domande Frequenti" />
  <h2 class="text-3xl leading-tight font-bold">Domande Frequenti</h2>
  <!--  <p class="text-lg mt-4 font-semibold">WIP</p>-->
  <div class="faq">
    <p class="mt-2 leading-relaxed">1. <strong>Quali sono gli orari di apertura della piscina?</strong></p>
    <p class="mt-2 leading-relaxed">La piscina è aperta tutti i giorni.</p>

    <!--
    <p class="mt-2 leading-relaxed">2. <strong>Posso portare cibo e bevande dall'esterno?</strong></p>
    <p class="mt-2 leading-relaxed">Siamo spiacenti, ma non è consentito portare cibo e bevande dall'esterno. Tuttavia,
      offriamo un'ampia selezione di cibo e bevande presso il nostro ristorante e bar.</p>
-->
    <p class="mt-2 leading-relaxed">2. <strong>C'è un costo per l'ingresso alla piscina?</strong></p>
    <p class="mt-2 leading-relaxed">Sì, è previsto un costo di ingresso giornaliero. I prezzi variano a seconda dell'età
      e del giorno della settimana. Per i bambini sotto 3 anni, l'ingresso è gratuito.</p>

    <p class="mt-2 leading-relaxed">3. <strong>Posso prenotare un lettino o un ombrellone?</strong></p>
    <p class="mt-2 leading-relaxed">Sì, è possibile prenotare lettini e ombrelloni in anticipo. È consigliabile prenotare in anticipo, specialmente durante i periodi di alta stagione.</p>

    <p class="mt-2 leading-relaxed">4. <strong>Avete corsi di nuoto per bambini?</strong></p>
    <p class="mt-2 leading-relaxed">Sì, offriamo corsi di nuoto per bambini di tutte le età. Contattateci per ulteriori
      informazioni sui corsi disponibili e sui costi.</p>

    <p class="mt-2 leading-relaxed">5. <strong>Posso portare il mio cane?</strong></p>
    <p class="mt-2 leading-relaxed">Siamo spiacenti, ma i cani non sono ammessi nella zona della piscina per motivi di
      sicurezza e igiene.</p>

    <p class="mt-2 leading-relaxed">6. <strong>Quali sono le misure di sicurezza in vigore nella piscina?</strong></p>
    <p class="mt-2 leading-relaxed">La sicurezza dei nostri ospiti è una priorità. Abbiamo personale qualificato in
      servizio per monitorare la piscina, ci sono anche salvagenti disponibili in caso di emergenza. Si prega di seguire
      le regole di sicurezza indicate in loco.</p>

    <p class="mt-2 leading-relaxed">7. <strong>Posso organizzare un evento privato presso la piscina?</strong></p>
    <p class="mt-2 leading-relaxed">Sì, siamo lieti di ospitare eventi privati ​​come feste di compleanno, riunioni di
      famiglia, matrimoni e altro ancora. Contattateci per discutere le vostre esigenze e le opzioni disponibili.</p>

    <p class="mt-2 leading-relaxed">8. <strong>Cosa succede in caso di maltempo?</strong></p>
    <p class="mt-2 leading-relaxed">In caso di pioggia o condizioni meteorologiche avverse, potremmo chiudere
      temporaneamente la piscina per motivi di sicurezza. Si prega di controllare la nostra pagina social o di
      contattarci per informazioni aggiornate sulle chiusure.</p>
  </div>

</template>

<script>
import PageLayout from "@/Pages/Home/Shared/PageLayout.vue";
import { Head } from "@inertiajs/inertia-vue3";

export default {
  components: {
    Head,
  },
  layout: PageLayout,
};
</script>
